import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginRight: theme.spacing.unit*2,
    marginLeft: theme.spacing.unit*2,
    minWidth: '75px',
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
});

const Estimate = ({ classes, task }) => {
  return(
    <div className={classes.root}>
      <div className={classes.divider}></div>
      <div className={classes.column}>
        {task.estimate &&
          <Typography variant="subheading">
            ${task.estimate}
          </Typography>
        }
      </div>
      <div className={classes.divider}></div>
    </div>
  );
};

export default withStyles(styles)(Estimate);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/Total/Estimate.jsx